import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../lib/api';

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || '';
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate('/login');
      return;
    }
    const sessionId = match[1];

    (async () => {
      try {
        const res = await api.post('/auth/session', { session_id: sessionId });
        const isNewUser = res.data.is_new_user;
        if (isNewUser) {
          window.location.href = '/complete-profile';
        } else {
          window.location.href = '/dashboard';
        }
      } catch (e) {
        setError('Gagal memproses login. Silakan coba lagi.');
        setTimeout(() => navigate('/login'), 2000);
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4" data-testid="auth-callback">
      <div className="border-2 border-foreground bg-white px-8 py-6 shadow-brutal-md text-center max-w-md">
        <p className="font-display text-2xl font-bold mb-2">Memproses Login</p>
        <p className="text-muted-foreground">{error || 'Sebentar ya, kami sedang memverifikasi akunmu...'}</p>
      </div>
    </div>
  );
}
